/**
 * @export
 * @class Applications
 */
import { getAll } from '../../helpers/utilities';

import { ApplicationsViewer } from './applications-viewer';

export class Applications {
    public static id = 'applications';


    /**
     * Initialises a new instance of Applications
     */
    constructor() {
        new ApplicationsViewer();
        this.toggleFilterState();
    }


    /**
     * Toggle the state of our filters on click
     * 
     * @private
     * @returns void
     */
    private toggleFilterState(): void {
        const filters = getAll('.js-applications__filter');
        if(filters) {
            filters.forEach(outerFilter => {
                outerFilter.addEventListener('click', () => {
                    const targetFilter = outerFilter;
                    filters.forEach(filter => {
                        if(filter === targetFilter) {
                            filter.classList.add('c-applications__filter-link--is-active');
                        } else {
                            filter.classList.remove('c-applications__filter-link--is-active');
                        }
                    });
                });
            });
        }
    }
}
